import AjaxPost from 'components/ajaxpost/ajaxpost';
import { handleUrlSearchParams } from 'helpers/urlsearchparams/urlSearchParams';
import { object } from 'zod';
import Validation, { phoneNumberValidation, requiredValidation, emailValidation } from 'vendor/zod/validationZod';

export const ContactFormB2B = (function () {
    // set initial config data
    const _config = {
        form: '#contactFormB2B',
        validationObject: null
    };

    const init = () => {
        if (document.querySelector(_config.form)) {
            _handleValidation();
        }
    };

    // init form validation
    const _handleValidation = () => {
        const schema = object({
            companyName: requiredValidation,
            firstName: requiredValidation,
            lastName: requiredValidation,
            email: requiredValidation.pipe(emailValidation),
            phoneNumber: requiredValidation.pipe(phoneNumberValidation),
            message: requiredValidation
        });

        const validationConfig = {
            form: _config.form,
            schema,
            onValidationSubmit: (validationObject) => {
                _handleFormSubmit(validationObject);
            }
        };

        _config.validationObject = new Validation(validationConfig); // Load validation
        _config.validationObject.initValidation();
    };

    /*-----------------------------FORM SUBMIT | submit the form------------------------------*/
    const _handleFormSubmit = (validationObject) => {
        const formElement = validationObject.config.formElement;

        const params = new handleUrlSearchParams({
            form: formElement,
            fieldSelector: '.form-control',
            addEmptyFields: true
        });
        const postData = params.renderSearchParams();

        const postForm = new AjaxPost({
            formElement,
            validationObject,
            postData,
            hideFormOnSuccess: true,
            messageContainer: document.getElementById('contact-message-container')
        });

        postForm.postFormData();
    };

    return {
        init: init
    };
})();
